(() => {
  if (window.Shopify && window.Shopify.designMode) {
    document.documentElement.classList.add('shopify-design-mode');
  }

  function makeBurst(x, y) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const layer = document.createElement('div');
    layer.className = 'cart-remove-burst-layer';
    document.body.appendChild(layer);

    const colors = ['#ff2d35', '#ff5a5f', '#ffffff', '#111111'];
    const count = 12;

    for (let i = 0; i < count; i += 1) {
      const dot = document.createElement('span');
      dot.className = 'cart-remove-burst-dot';
      const angle = (Math.PI * 2 * i) / count;
      const distance = 18 + Math.random() * 22;
      const size = 4 + Math.random() * 5;

      dot.style.left = `${x}px`;
      dot.style.top = `${y}px`;
      dot.style.width = `${size}px`;
      dot.style.height = `${size}px`;
      dot.style.background = colors[Math.floor(Math.random() * colors.length)];
      dot.style.setProperty('--tx', `${Math.cos(angle) * distance}px`);
      dot.style.setProperty('--ty', `${Math.sin(angle) * distance}px`);
      layer.appendChild(dot);
    }

    window.setTimeout(() => layer.remove(), 600);
  }

  function getRemoveButton(target) {
    return target?.closest?.('#CartDrawer cart-remove-button button, #CartDrawer .cart-remove-button, #CartDrawer .cart-item__remove');
  }

  let pendingRemoval = null;

  document.addEventListener('click', (event) => {
    const button = getRemoveButton(event.target);
    if (!button) return;
    const rect = button.getBoundingClientRect();
    pendingRemoval = {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
      expiresAt: Date.now() + 12000,
    };
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const button = getRemoveButton(document.activeElement);
    if (!button) return;
    const rect = button.getBoundingClientRect();
    pendingRemoval = {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
      expiresAt: Date.now() + 12000,
    };
  });

  const confirmRemoval = () => {
    if (!pendingRemoval || pendingRemoval.expiresAt < Date.now()) {
      pendingRemoval = null;
      return;
    }
    makeBurst(pendingRemoval.x, pendingRemoval.y);
    pendingRemoval = null;
  };

  if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS?.cartUpdate) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, confirmRemoval);
  }
  window.RetroPartyCartRemoveAnimation = true;
})();
